import * as actionTypes from 'constants/ActionTypes';
import helpers from 'helpers';
import moment from 'moment';
import _ from 'lodash';

const statisticsCargoRequests = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
    from: '',
    until: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_STATISTICS_CARGO_REQUESTS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_STATISTICS_CARGO_REQUESTS.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_STATISTICS_CARGO_REQUESTS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        default:
            return state;
    }
};

export default statisticsCargoRequests;



// WEBPACK FOOTER //
// ./app/reducers/statistics/cargoRequests.js